// Country registry — single source of truth for the frontend.
// Kept in sync with /app/backend/config/countries.py.
//
// `languages` = the language codes offered in that country's language
// switcher. First item is the default when a visitor first lands. If a
// country only offers one language, the switcher hides the language
// column (see CountryLanguageSelector).
//
// The `active` flag is NOT tracked here — it lives in the backend
// `country_settings` collection and is loaded by CountryContext at boot.
// Every entry below is a KNOWN country; whether the visitor sees it
// depends on the admin toggle at /admin/countries.

export const DEFAULT_COUNTRY = "HK";

export const COUNTRIES = [
    { code: "HK", name: "Hong Kong",             flag: "🇭🇰", currency: "HKD", languages: ["zh-HK", "en", "zh-CN"] },
    { code: "SG", name: "Singapore",             flag: "🇸🇬", currency: "SGD", languages: ["en", "zh-CN"] },
    { code: "TW", name: "Taiwan",                flag: "🇹🇼", currency: "TWD", languages: ["zh-HK", "en", "zh-CN"] },
    { code: "TH", name: "Thailand",              flag: "🇹🇭", currency: "THB", languages: ["en"] },
    { code: "MY", name: "Malaysia",              flag: "🇲🇾", currency: "MYR", languages: ["en", "zh-CN"] },
    { code: "PH", name: "Philippines",           flag: "🇵🇭", currency: "PHP", languages: ["en"] },
    { code: "VN", name: "Vietnam",               flag: "🇻🇳", currency: "VND", languages: ["en"] },
    { code: "AE", name: "United Arab Emirates",  flag: "🇦🇪", currency: "AED", languages: ["en"] },
    { code: "AU", name: "Australia",             flag: "🇦🇺", currency: "AUD", languages: ["en"] },
    { code: "NZ", name: "New Zealand",           flag: "🇳🇿", currency: "NZD", languages: ["en"] },
    { code: "UK", name: "United Kingdom",        flag: "🇬🇧", currency: "GBP", languages: ["en"] },
    { code: "US", name: "United States",         flag: "🇺🇸", currency: "USD", languages: ["en"] },
];

export const COUNTRY_CODES = COUNTRIES.map((c) => c.code);

export function getCountry(code) {
    return (
        COUNTRIES.find((c) => c.code === code) ||
        COUNTRIES.find((c) => c.code === DEFAULT_COUNTRY)
    );
}

// Default UI language for a country = first entry in its languages
// list. Auto-applied on country switch (unless the visitor has manually
// picked a language — see CountryContext).
export function defaultLanguageFor(countryCode) {
    return getCountry(countryCode).languages[0];
}

// Language codes available in a given country. Powers the filtered
// language switcher.
export function languagesForCountry(countryCode) {
    return getCountry(countryCode).languages;
}
